/**
 * Normalizes a location string for use as a URL path segment.
 * Produces slugs like "Helsinki_Finland", "Remote_-_Europe", never commas or leading/trailing underscores.
 *
 * Used by: Algolia router, url-handling, +Head canonical/breadcrumb, redirects.
 */
export function toLocationSlug(raw: string | null | undefined): string {
  if (raw == null || typeof raw !== 'string') return '';
  let s = raw.trim();
  if (!s) return '';
  // Comma (with optional spaces) and spaces → underscore; preserve " - " as _-_ for "Remote - X"
  s = s.replace(/,\s*/g, '_').replace(/\s*-\s*/g, '_-_').replace(/\s+/g, '_');
  // Collapse multiple underscores
  s = s.replace(/__+/g, '_');
  // Strip leading/trailing underscores (e.g. ", Finland" → "_Finland" → "")
  s = s.replace(/^_+|_+$/g, '');
  return s;
}
